// src/pages/CourseTime/components/slides/layouts/StepBlockSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken, { resolveSlideTitle } from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateStepBlock
const StepBlockSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  // Shared refs/ state for title heights (TemplateStepBlock)
  const titleRefs = React.useRef([]);
  const [maxTitleHeight, setMaxTitleHeight] = React.useState(0);

  React.useEffect(() => {
    if (slide?.SlideLayout !== 'TemplateStepBlock' || !Array.isArray(slide?.SlideContent)) {
      setMaxTitleHeight(0);
      titleRefs.current = [];
      return;
    }

    const heights = titleRefs.current
      .slice(0, slide.SlideContent.length)
      .map(el => (el?.offsetHeight ? el.offsetHeight : 0));

    if (!heights.length) return;

    const max = Math.max(...heights);
    if (max && max !== maxTitleHeight) {
      setMaxTitleHeight(max);
    }
  }, [slide, maxTitleHeight]);

  const stepCount = Array.isArray(slide.SlideContent) ? slide.SlideContent.length : 0;
  const isCondensed = stepCount > 3;
  const isSingleItem = stepCount === 1;

  return (
    <>
      {resolveSlideTitle(slide) ? (
        <S.SlideTitle style={{ textAlign: 'center' }}>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>
      ) : null}
      <S.StepBlockContainer>
        {Array.isArray(slide.SlideContent) &&
          slide.SlideContent.map((step, idx) => {
            if (!step) return null;

            const title = step.Title;
            // Body text (step.Text) can now contain HTML tags renderContent handles that
            const bodyText = step.Text;

            return (
              <S.StepColumn key={idx} issingle={isSingleItem} stepcount={stepCount}>
                {title && (
                  <S.TitleBox
                    ref={el => {
                      titleRefs.current[idx] = el;
                    }}
                    style={{minHeight: maxTitleHeight || 'auto',}}
                  >
                  <S.StepTitle iscondensed={isCondensed}>
                    {renderContent(`content_${idx}_title`, title)}
                  </S.StepTitle>
                  </S.TitleBox>
                )}
                {bodyText && (
                  <S.StepText iscondensed={isCondensed}>
                    {renderContent(`content_${idx}_text`, bodyText)}
                  </S.StepText>
                )}
              </S.StepColumn>
            );
          })}
      </S.StepBlockContainer>
    </>
  );
};

export default StepBlockSlide;
